import React from 'react';
import { getVideoSetting, ProviderKlarityMeetingRoomSetting } from 'api/videoSetting';

const useVideoSetting = (): [ProviderKlarityMeetingRoomSetting | undefined, boolean, () => void] => {
    const loading = React.useRef(false);
    const [data, setData] = React.useState<ProviderKlarityMeetingRoomSetting>();
    const fetchData = async () => {
        if (loading.current) {
            return;
        }
        try {
            loading.current = true;
            const result = await getVideoSetting();
            if (result?.data?.data) {
                setData(result.data.data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    return [data, loading.current, fetchData];
};

export default useVideoSetting;
